import styled from "styled-components";
import NoTextSelectionStyles from "../../../common/styles/no-text-selection";

export const MetricsSC = styled.div`
    padding: 28px 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
    border: 1px solid #e3dcc7;
    border-radius: 12px;
     ${NoTextSelectionStyles}

    .stat-item {
        text-align: center;
        min-width: 140px;
    }

    .stat-item h3 {
        font-size: 26px;
        font-weight: 600;
        color: #111827;
        margin: 0 0 6px;
    }

    .stat-item p {
        font-size: 13.5px;
        color: #6b7280;
        margin: 0;
        white-space: nowrap;
    }

    .stat-divider {
        width: 1px;
        height: 40px;
        background: #e3dcc7;
    }

    @media (max-width: 768px) {
        padding: unset;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 0px;
        margin-bottom: -26px;

        .mobile-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0px;
            margin: 0px;
        }

        .stat-item {
            width: 50%;
            height: 80px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .stat-item h3 {
            font-size: 18px;
            font-weight: 600;
            color: #3f3e3e;
        }

        .stat-item p {
            font-size: 12px;
            width: 70%;
            white-space: pre-wrap;
        }

        .stat-divider {
            height: 80px;
            width: 1px;
            margin: 0px;
            padding: 0px;
        }

        .stat-line-divider {
            width: 100%;
            height: 1px;
            background: #e3dcc7;
        }
    }
`